export default __webpack_public_path__ + "static/media/happy.72fa50b0.png";